const musicLinksHR = {
    "view": {
        "table": {
            "title": "Popis vaših glazbenih poveznica",
            "column": {
                "releaseName": "Naziv izdanja",
                "artists": "Umjetnici",
                "owner": "Vlasnik",
                "created": "Stvoreno",
                "musicLink": "Glazbena poveznica",
                "action": "Akcija"
            },
            "button": {
                "export_csv": "Izvoz CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "message": {
                "linkCopied": "Poveznica kopirana u međuspremnik!"
            }
        },
        "modal": {
            "edit": {
                "header": "Uredi {{musicLinkName}}?",
                "body": "Jeste li sigurni da želite urediti ovu glazbenu poveznicu?"
            },
            "delete": {
                "header": "Izbriši {{musicLinkName}}?",
                "body": "Jeste li sigurni da želite izbrisati ovu glazbenu poveznicu?"
            }
        },
        "message": {
            "success": "Glazbena poveznica je uklonjena!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!",
            "mlAllowanceSpent": "Potrošili ste svoju kvotu za glazbene poveznice. Da biste stvorili više glazbenih poveznica, nadogradite svoj račun ili kontaktirajte naš tim za podršku.",
            "subscriptionFeatureUnavailable": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste iskoristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste iskoristili ovu značajku.",
            "moduleAccessRestricted": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za više informacija."
        }
    },
    "add": {
        "title": "Dodaj glazbenu poveznicu",
        "form": {
            "label": {
                "source": "Izvor",
                "subUser": "Pod-korisnik",
                "release": "Izdanje",
                "artwork": "Umjetničko djelo",
                "releaseName": "Naziv izdanja",
                "upcEan": "UPC/EAN",
                "artistName": "Ime umjetnika",
                "urlPart1": "Url dio1",
                "urlPart2": "Url dio2",
                "musicLinkUrl": "Vaša glazbena poveznica URL je",
                "searchBy": "Pretraži po",
                "upcNumber": "UPC broj",
                "storeReleaseUrl": "URL izdanja u trgovini",
                "colorCustomisation": "Prilagodba boja",
                "premadeColors": "Unaprijed izrađene boje",
                "customColors": "Prilagođene boje",
                "buttonStyle": "Stil gumba",
                "headerBackground": "Pozadina zaglavlja",
                "singleColor": "Jedna boja",
                "gradient": "Gradijent",
                "playerControlsColor": "Boja kontrola playera",
                "titleColor": "Boja naslova",
                "descriptionColor": "Boja opisa",
                "buttonColor": "Boja gumba",
                "buttonHoverColor": "Boja gumba pri prelasku",
                "buttonTextColor": "Boja teksta gumba"
            },
            "placeholder": {
                "subUser": "Odaberite pod-korisnika...",
                "release": "Odaberite izdanje",
                "releaseUpc": "Unesite broj UPC/EAN izdanja npr. 5055964352523",
                "releaseStoreUrl": "Unesite URL izdanja u trgovini npr. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ili www.deezer.com/en/album/413370367",
                "urlPart1": "Odaberite Url dio 1"
            },
            "help_text": {
                "subUser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati glazbenu poveznicu za bilo kojeg od svojih pod-korisnika, inače ostavite neodabrano.",
                "release": "Napomena: Možete odabrati samo izdanja koja su <strong>Distribuirana.</strong>",
                "releaseUpc": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje koje je već na Spotifyju ili Deezeru.",
                "releaseStoreUrl": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje koje je već na Spotifyju ili Deezeru."
            },
            "options": {
                "source": {
                    "existingRelease": "Postojeće izdanje glazbene poveznice",
                    "externalRelease": "Vanjsko izdanje"
                },
                "buttonStyle": {
                    "outlined": "Obrisano",
                    "filled": "Ispunjeno"
                }
            },
            "button": {
                "reset": "Poništi",
                "createNew": "Stvori novo?",
                "submit": "Pošalji"
            },
            "validation": {
                "formInvalid": "Obrazac se ne može poslati! Molimo ispunite sva polja i provjerite pogreške!",
                "storeUrlRequired": "{{store}} Url je obavezan",
                "storeUrlValid": "Molimo dodajte važeći {{store}} Url."
            }
        },
        "message": {
            "success": "Glazbena poveznica je dodana!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!",
            "fetchingReleaseDetails": "Dohvaćanje detalja izdanja..."
        }
    },
    "update": {
        "title": "Uredi glazbenu poveznicu",
        "form": {
            "label": {
                "source": "Izvor",
                "release": "Izdanje",
                "artwork": "Umjetničko djelo",
                "releaseName": "Naziv izdanja",
                "upcEan": "UPC/EAN",
                "artistName": "Ime umjetnika",
                "urlPart1": "Url dio1",
                "urlPart2": "Url dio2",
                "musicLinkUrl": "Vaša glazbena poveznica URL je",
                "searchBy": "Pretraži po",
                "upcNumber": "UPC broj",
                "storeReleaseUrl": "URL izdanja u trgovini",
                "colorCustomisation": "Prilagodba boja",
                "premadeColors": "Unaprijed izrađene boje",
                "customColors": "Prilagođene boje",
                "buttonStyle": "Stil gumba",
                "headerBackground": "Pozadina zaglavlja",
                "singleColor": "Jedna boja",
                "gradient": "Gradijent",
                "playerControlsColor": "Boja kontrola playera",
                "titleColor": "Boja naslova",
                "descriptionColor": "Boja opisa",
                "buttonColor": "Boja gumba",
                "buttonHoverColor": "Boja gumba pri prelasku",
                "buttonTextColor": "Boja teksta gumba"
            },
            "placeholder": {
                "release": "Odaberite izdanje",
                "releaseUpc": "Unesite broj UPC/EAN izdanja npr. 5055964352523",
                "releaseStoreUrl": "Unesite URL izdanja u trgovini npr. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ili www.deezer.com/en/album/413370367",
                "urlPart1": "Odaberite Url dio 1"
            },
            "help_text": {
                "release": "Napomena: Možete odabrati samo izdanja koja su <strong>Distribuirana.</strong>",
                "releaseUpc": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje koje je već na Spotifyju ili Deezeru.",
                "releaseStoreUrl": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje koje je već na Spotifyju ili Deezeru."
            },
            "options": {
                "source": {
                    "existingRelease": "Postojeće izdanje glazbene poveznice",
                    "externalRelease": "Vanjsko izdanje"
                },
                "buttonStyle": {
                    "outlined": "Obrisano",
                    "filled": "Ispunjeno"
                }
            },
            "button": {
                "reset": "Poništi",
                "createNew": "Stvori novo?",
                "submit": "Pošalji"
            },
            "validation": {
                "formInvalid": "Obrazac se ne može poslati! Molimo ispunite sva polja i provjerite pogreške!",
                "storeUrlRequired": "{{store}} Url je obavezan",
                "storeUrlValid": "Molimo dodajte važeći {{store}} Url."
            }
        },
        "message": {
            "success": "Glazbena poveznica je ažurirana!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!",
            "fetchingReleaseDetails": "Dohvaćanje detalja izdanja..."
        }
    },
    "storeLinksRow": {
        "title": "Poveznice trgovine",
        "label": {
            "store": "Trgovina",
            "link": "Poveznica"
        },
        "button": {
            "remove": "Ukloni"
        },
        "model": {
            "addStore": {
                "header": "Dodaj trgovinu",
                "body": "Molimo odaberite željenu trgovinu s popisa ispod:",
                "option": {
                    "mainStores": "Glavne trgovine",
                    "otherStores": "Ostale trgovine"
                },
                "button": {
                    "add": "Dodaj trgovinu",
                    "cancel": "Otkaži"
                }
            }
        }
    },
    "previewFilesRow": {
        "title": "Pregled datoteka",
        "label": {
            "preview": "Pregled",
            "artistName": "Ime umjetnika",
            "trackName": "Naziv pjesme"
        },
        "audioNotSupported": "Vaš preglednik ne podržava audio element."
    },
    "landingPagePreview": {
        "label": {
            "chooseMusicService": "Odaberite glazbenu uslugu",
            "track": "Pjesma",
            "artist": "Umjetnik",
            "time": "Vrijeme",
            "others": "Ostalo"
        },
        "button": {
            "play": "Reproduciraj"
        }
    },
    "viewStats": {
        "label": {
            "fetchingStats": "Dohvaćanje statistike za glazbenu poveznicu"
        },
        "topServices": {
            "title": "Najbolje usluge",
            "subtitle": "KLIKNITE PREKO USLUGE",
            "table": {
                "column": {
                    "store": "Trgovina",
                    "noOfVisits": "Ukupno posjeta",
                    "noOfVisitsPct": "Ukupno posjeta %"
                },
                "label": {
                    "otherStores": "Ostale trgovine"
                }
            }
        },
        "topTracks": {
            "title": "Najbolje pjesme",
            "subtitle": "KLIKNITE PREKO PJESME",
            "table": {
                "column": {
                    "trackName": "Naziv pjesme",
                    "artistName": "Ime umjetnika",
                    "noOfPlays": "Broj reprodukcija",
                    "noOfPlaysPct": "Broj reprodukcija %"
                }
            }
        },
        "topTerritories": {
            "title": "Najbolje teritorije",
            "subtitle": "KLIKNITE PREKO TERITORIJA",
            "table": {
                "column": {
                    "territory": "Teritorij",
                    "noOfViews": "Broj pregleda",
                    "noOfViewsPct": "Broj pregleda %"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Najbolje vrste uređaja",
            "subtitle": "KLIKNITE PREKO VRSTE UREĐAJA"
        },
        "topOperatingSystems": {
            "title": "Najbolji operativni sustavi",
            "subtitle": "KLIKNITE PREKO OS",
            "chart": {
                "label": {
                    "noOfViews": "Broj pregleda : ",
                    "operatingSystems": "Operativni sustav"
                }
            }
        },
        "topBrowsers": {
            "title": "Najbolji preglednici",
            "subtitle": "KLIKNITE PREKO PREGLEDNIKA",
            "table": {
                "column": {
                    "browser": "Preglednik",
                    "noOfViewsPct": "Broj pregleda (%)"
                }
            }
        }
    }
};

export default musicLinksHR;